// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import SuivipaiementService from '../../services/SuivipaiementService';
import ParentService from '../../services/ParentService';
import EleveService from '../../services/EleveService';
import AnneescolaireService from '../../services/AnneescolaireService';

const OffcanvasAddSuivipaiementForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [EleveOptions, setEleveOptions] = useState([]);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);
	const [ParentOptions, setParentOptions] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);

				const Parents = await ParentService.getParentOptions();
				setParentOptions(Parents);

				const Eleves = await EleveService.getEleveOptions();
				setEleveOptions(Eleves);
			} catch (error) {
				console.error('Erreur lors de la récupération des données:', error);
				// Replace the native alert with a Bootstrap alert or a custom notification
				setAlertMessage(
					`Erreur lors de la récupération des données. Détails de l'erreur : ${error.message}`
				);
				setShowAlert(true);
			}
		};

		fetchData();
	}, []);

	const Eleve_CHOICES = EleveOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const suivipaiementData = new FormData();

				// Add all your form data to the FormData
				suivipaiementData.append('eleve', form.eleve.value);
				suivipaiementData.append('montant_paye', form.montant_paye.value);
				suivipaiementData.append(
					'tenue_classe_payee',
					form.tenue_classe_payee.checked
				);
				suivipaiementData.append('pull_payee', form.pull_payee.checked);
				suivipaiementData.append(
					'tenue_sport_payee',
					form.tenue_sport_payee.checked
				);
				suivipaiementData.append('date_paiement', form.date_paiement.value);
				suivipaiementData.append('anneescolaire', currentSchoolYear.id);

				// Call the SuivipaiementService to create the Suivipaiement
				const response = await SuivipaiementService.createSuivipaiement(
					suivipaiementData
				);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Bulletinnotes
				window.location.href = '/finances/scolarite/suivipaiement';
			} catch (error) {
				console.error('Erreur lors de la création du paiement', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				{/* eleve */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="eleve">Eleve</Form.Label>
						<Form.Select
							name="eleve"
							required
							isInvalid={!!feedbackMessages['eleve']}
							onChange={(e) => {
								const value = e.target.value;
								const feedbackMessage = value
									? ''
									: 'Vous devez sélectionner un élève.';
							}}
						>
							<option value="">Selectionner un élève</option>
							{Eleve_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['eleve']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* tenue_sport_payee */}
				<Col xs={12}>
					<Form.Group className="mb-3">
						<Form.Check
							name="tenue_sport_payee"
							type="checkbox"
							id="tenue_sport_payee"
							label="Tenue de Sport"
							isInvalid={!!feedbackMessages['tenue_sport_payee']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : ''
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['tenue_sport_payee']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/*  tenue_classe_payee  */}
				<Col xs={12}>
					<Form.Group className="mb-3">
						<Form.Check
							name="tenue_classe_payee"
							type="checkbox"
							id="tenue_classe_payee"
							label="Tenue de Classe"
							isInvalid={!!feedbackMessages['tenue_classe_payee']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : ''
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['tenue_classe_payee']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/*  pull_payee  */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Check
							name="pull_payee"
							type="checkbox"
							id="pull_payee"
							label="Pull"
							isInvalid={!!feedbackMessages['pull_payee']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : ''
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['pull_payee']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Montan restant */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="montant_paye">
							Montant versé <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="montant_paye"
							type="number"
							required
							placeholder="Saisir le montant versé "
							id="montant_paye"
							isInvalid={!!feedbackMessages['montant_paye']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									montant_paye: e.target.value
										? ''
										: 'Le montant versé est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['montant_paye']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* date_paiement */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="date_paiement">
							Date de Paiement <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="date_paiement"
							type="date"
							required
							placeholder="Saisir la Date de Paiement"
							id="date_paiement"
							isInvalid={!!feedbackMessages['date_paiement']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : 'La Date de Paiement est requise'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['date_paiement']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddSuivipaiementForm;
